/**
 * 作者：张小彤
 * 时间：2016/12/12
 * 描述：左面文件
 */

import React, {Component} from 'react';

import './left.scss';


export default class Left extends Component{
    componentDidMount(){
        $('.left').css('height',$(window).height() - 110 +'px')
        $('.ullist ').on('click','li',function(){
            $(this).addClass('leftactive').siblings().removeClass();
            $('.rightcontaions > div').removeClass('block').addClass('none').eq($(this).index()).removeClass('none').addClass('block');
        })
    }
    render() {
        return (
            <div className="l left">
                <ul className="ullist">
                    <li className="leftactive"><a href="javascript:void(0);">SDK下载</a></li>
                    <li><a href="javascript:void(0);">文档帮助</a></li>
                    <li><a href="javascript:void(0);">常见问题</a></li>
                </ul>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./D:/front-end-svn/webpack/src/project/sdk/components/left/left.jsx